export const pageTitleData = {
  Verification: 'Rx Incentives: Verification Page Rx',
  Communication: 'Rx Incentives: Communication Opt-in',
  GovtIns: 'Rx Incentives: Govt Ins Verification',
  EligibleCoupons: 'Rx Incentives: Eligible Coupons',
  NoOffers: 'Rx Incentives: No Offers Rx',
  ErrorPage: 'Rx Incentives: Unable to Verify Account Rx',
  ErrorPageIMZ: 'Rx Incentives: Unable to Verify Account IMZ',
  NoOffersIMZ: 'Rx Incentives: No Offers IMZ',
  VerificationIMZ: 'Rx Incentives: Verification Page IMZ',
  UserInfo: 'Rx Incentives: Multiple Accounts',
  offerConfirm: 'Rx Incentives: Offer is ready to use Rx',
  offerConfirmIMZ: 'Rx Incentives: Offer is ready to use IMZ',
  noPharmacyOffer: 'Rx Incentives: No offer for health plans members Rx',
  noPharmacyOfferIMZ: 'Rx Incentives: No offer for health plans members IMZ',
  noOffer: 'Rx Incentives: No Pharmacy Offer Rx',
  noOfferIMZ: 'Rx Incentives: No Pharmacy Offer IMZ',
  unSubsCribe: 'Rx Incentives: UnSubscribe user Rx',
  unSubsCribeIMZ: 'Rx Incentives: UnSubscribe user IMZ',
  genericError: 'Rx Incentives: Something went wrong Rx',
  genericErrorIMZ: 'Rx Incentives: Something went wrong IMZ',
  Prescriptioncount: 'Rx Incentives: Prescriptioncount Rx',
  PrescriptioncountIMZ: 'Rx Incentives: Prescriptioncount IMZ',
  consentForm: 'Rx Incentives: confirming consent',
  consentFormIMZ: 'Rx Incentives:confirming consent IMZ',
  hipaaConsent: 'Rx Incentives: HIPAA marketing authorization',
  imzDeprecation: 'Rx Incentives: Imz Deprecation Page',
};
export const gtmDataObject = {
  Verification: {
    page: {
      pageName: 'Rx Incentives: Verification Page Rx',
      channel: 'Rx Incentives',
      pageType: 'Rx Incentives',
      banner: 'albertsons',
      subSection1: 'Verification Page',
      pageUrl: '',
      platform: 'web',
    },
    user: {
      authType: 'Guest',
      shopZipCode: '',
      shopStoreId: '',
      banner: 'albertsons',
    },
  },
  Communication: {
    page: {
      pageName: 'Rx Incentives: Communication Opt-in',
      pageType: 'Rx Incentives',
      channel: 'Rx Incentives',
      banner: 'albertsons',
      subSection1: 'Communication Opt-in',
      pageUrl: '',
      platform: 'web',
    },
    user: {
      authType: 'Guest',
      shopZipCode: '',
      shopStoreId: '',
      banner: 'albertsons',
    },
  },
  HipaaConsent: {
    page: {
      pageName: 'Rx Incentives: Hipaa marketing consent',
      pageType: 'Rx Incentives',
      channel: 'Rx Incentives',
      banner: 'albertsons',
      subSection1: 'Hipaa marketing consent',
      pageUrl: '',
      platform: 'web',
    },
    user: {
      authType: 'Guest',
      shopZipCode: '',
      shopStoreId: '',
      banner: 'albertsons',
    },
  },
  GovtIns: {
    page: {
      pageName: 'Rx Incentives: Govt Ins Verification',
      channel: 'Rx Incentives',
      banner: 'albertsons',
      subSection1: 'Govt Ins Verification',
      pageUrl: '',
      platform: 'web',
      pageType: 'Rx Incentives',
    },
    user: {
      authType: 'Guest',
      shopZipCode: '',
      shopStoreId: '',
      banner: 'albertsons',
    },
  },
  EligibleCoupons: {
    page: {
      pageName: 'Rx Incentives: Eligible Coupons',
      channel: 'Rx Incentives',
      banner: 'albertsons',
      subSection1: 'Eligible Coupons',
      pageUrl: '',
      platform: 'web',
      pageType: 'Rx Incentives',
    },
    user: {
      authType: 'Guest',
      shopZipCode: '',
      shopStoreId: '',
      banner: 'albertsons',
    },
  },
  NoOffers: {
    page: {
      pageName: 'Rx Incentives: No Offers IMZ',
      channel: 'Rx Incentives',
      banner: 'albertsons',
      subSection1: 'No Offers',
      pageUrl: '',
      platform: 'web',
      pageType: 'Rx Incentives',
    },
    user: {
      authType: 'Guest',
      shopZipCode: '',
      shopStoreId: '',
      banner: 'albertsons',
    },
  },
  ErrorPage: {
    page: {
      pageName: 'Rx Incentives: Unable to Verify Account Rx',
      channel: 'Rx Incentives',
      banner: 'albertsons',
      subSection1: 'Unable to Verify Account',
      pageUrl: '',
      platform: 'web',
      pageType: 'Rx Incentives',
    },
    user: {
      authType: 'Guest',
      shopZipCode: '',
      shopStoreId: '',
      banner: 'albertsons',
    },
  },
  UserInfo: {
    page: {
      pageName: 'Rx Incentives: Multiple Accounts',
      channel: 'Rx Incentives',
      banner: 'albertsons',
      subSection1: 'Multiple Accounts',
      pageUrl: '',
      platform: 'web',
      pageType: 'Rx Incentives',
    },
    user: {
      authType: 'Guest',
      shopZipCode: '',
      shopStoreId: '',
      banner: 'albertsons',
    },
  },
};
